import React from 'react';
import { useSelector } from 'react-redux';
import { TemplateDetailsContainer, useStyles } from './modalDialog.styled';
import Modal from 'src/common/components/modal/index';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import {
    hideScrolling,
    resumeScrolling,
    isMobileView,
    updateDialogPosition,
    logErrorToConsole,
} from 'src/utils/util';
import styled from 'styled-components';
import CloseButton from 'src/assets/images/CloseProduct.svg';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export default function index({
    isFromQRCodePopup,
    isIPadPotrait,
    zIndex,
    handleClose,
    isMobileDevice,
    afterSubmitTemplate,
    marginTop,
    height,
    paddingBottom,
    mbPaddingBottom,
    overflowX,
    overflowY,
    borderTopLeftRadius,
    background,
    backdropFilter,
    padding,
    width,
    left,
    top,
    right,
    crossMarginTop,
    marginBottom,
    modalHeight,
    ipadModalHeight,
    modalWidth,
    smalModalWidth,
    maxWidth,
    border,
    mobilePaperFullScreenHeight,
    isFromMobile,
    containerRight,
    containerWidth,
    children,
    hideCloseIcon,
    closeIconStyle,
    closeIconZIndex,
    id,
    isSurgery,
    isFromBomChangeNotification = false,
    backdropColor,
    modalMaxHeight='',
    modalMinHeight='',
    isAccountPage,
    isAdminPage,
    removeClipPath,
    fromTemplate
}) {
    const theme = useTheme();
  const resolutionMatchesDefault = useMediaQuery(theme.breakpoints.up('sm'));
    const resolutionMatchesIPad = useMediaQuery('(min-width:576px)');
    const isIpadPr = useMediaQuery(theme.breakpoints.up('pr'));
 
    //isIPadPotrait props comes from Order Details. used to show dialog instead of modal in Ipad-potrait mode
   
    let resolutionMatches = resolutionMatchesDefault;
    let isIpad = true;
    if (isIPadPotrait) {
        resolutionMatches = resolutionMatchesIPad;
        isIpad = isIpadPr;
    }
    //borderTopLeftRadius & borderTopRightRadius & marginTop made as dynamic for Ipad-potrait mode style is diffrent
    //swapped styles function based on isIPadPotrait.

    const { bannerHeight } = useSelector((state) => state?.loginReducer);

    const isBanner = bannerHeight && bannerHeight !== '' ? true : false;

    const classes = useStyles({
        height: isMobileDevice
            ? afterSubmitTemplate
                ? '102%'
                : height
                    ? height
                    : '101.7%'
            : height,
        mobilePaperFullScreenHeight: mobilePaperFullScreenHeight,
        paddingBottom: paddingBottom,
        mbPaddingBottom: mbPaddingBottom,
        overflowX: overflowX,
        marginTop:
           isFromQRCodePopup &&
                isMobileDevice
                    ? '1rem':
            isIPadPotrait && !isIpad && resolutionMatches
                ? '7.5rem'
                : isMobileDevice && !afterSubmitTemplate
                    ? '16.1rem'
                    : isMobileDevice && afterSubmitTemplate
                        ? '15.9rem'
                        : marginTop,
        borderTopLeftRadius: borderTopLeftRadius ? borderTopLeftRadius : (isFromMobile ? '5px' :
            isIPadPotrait &&
            !isIpad &&
            resolutionMatches &&
            !isBanner &&
            '0px'),
        borderTopRightRadius: borderTopLeftRadius ? borderTopLeftRadius : (isFromMobile ? '5px' :
            isIPadPotrait &&
            !isIpad &&
            resolutionMatches &&
            !isBanner &&
            '0px'),
        background: background,
        backdropFilter: backdropFilter,
        backdrop:
            ((isIPadPotrait && !isIpad && resolutionMatches) ||
                isMobileView()) &&
            bannerHeight &&
            bannerHeight !== '' &&
            zIndex > 1999 &&
            '#000000cc 0% 0% no-repeat padding-box',
        right: containerRight,
        width: containerWidth,
    });

    useEffectWithErrorLogging(() => {
        return () => {
            resumeScrolling();
        };
    }, []);

    return (
        <TemplateDetailsContainer id={id} isIPadPotrait={isIPadPotrait}>
            <Dialog
                disableScrollLock={true}
                fullScreen
                open={resolutionMatches && isIpad ? false : true}
                onClose={(event,reason) => {                    
                    if(reason === 'backdropClick'){
                        handleClose && handleClose();
                    }
                }}                   
                style={{
                    zIndex: zIndex ? zIndex : 1000,
                    marginBottom: marginBottom,
                }}
                BackdropProps={{
                    classes: {
                        root: classes.root,
                    },
                    style: {
                        backgroundColor:
                            backdropColor !== undefined && backdropColor !== null
                                ? backdropColor
                                : 'rgba(0, 0, 0, 0.7)',
                        position: 'absolute',
                    },
                }}

                onBlur={() => {
                    try {
                        hideScrolling();
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
                onFocus={() => {
                    try {
                        resumeScrolling();
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
                classes={{
                    container: classes.container,
                    paperFullScreen: classes.paperFullScreen,
                }}
            >
                {hideCloseIcon ? null : (
                    <CloseWrapper closeIconStyle={closeIconStyle} closeIconZIndex={closeIconZIndex} id="modal-close-icon">
                        <img
                            src={CloseButton}
                            width="100%"
                            height="100%"
                            alt="closeButton"
                            onClick={handleClose}
                        />
                    </CloseWrapper>
                                    )}
                {children}
            </Dialog>

            <div className="web ModalWebConatiner">
                <Modal
                    onLoad={() => {
                        try {
                            resumeScrolling();
                            updateDialogPosition('absolute');
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    onBlur={() => {
                        try {
                            hideScrolling();
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    showBackdrop={true}
                    closeSideNavBar={true}
                    hideCloseIcon={hideCloseIcon}
                    isModal={true}
                    closeModal={() => {
                        try {
                            handleClose();
                            updateDialogPosition('unset');
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    crossMarginTop={crossMarginTop}
                    closeIconZIndex={closeIconZIndex}
                    removeClipPath={removeClipPath}
                    padding={padding}
                    width={width}
                    left={left}
                    top={top}
                    right={right}
                    modalHeight={modalHeight}
                    modalMaxHeight={modalMaxHeight}
                    modalMinHeight={modalMinHeight}
                    ipadModalHeight={ipadModalHeight}
                    modalWidth={modalWidth}
                    smalModalWidth={smalModalWidth}
                    maxWidth={maxWidth}
                    overflowX={overflowX}
                    border={border}
                    background={background}
                    isSurgery = {isSurgery}
                    overflowY={overflowY}
                    isAccountPage = {isAccountPage}
                    isFromBomChangeNotification={isFromBomChangeNotification}
                    isAdminPage={isAdminPage}
                    fromTemplate={fromTemplate}
                >
                    {children}
                </Modal>
            </div>
        </TemplateDetailsContainer>
    );
}

const CloseWrapper = styled.div.attrs(props => ({
    id: props.id || 'modal-dialog'
    }))`
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: ${({ closeIconZIndex }) =>
        closeIconZIndex !== undefined ? closeIconZIndex : 9999};
    width: 21px;
    height: 20px;
    cursor: pointer;
    body.admin-impersonate-proxy-popup-open & {
        display: none;
    }
    ${({ closeIconStyle }) => closeIconStyle && closeIconStyle}
`;
